import React, { RefObject, useMemo } from 'react'
import { Form, Input as InputAntd } from 'antd'
import { InputProps, TextAreaProps } from 'antd/lib/input'
import { FormItemProps } from 'antd/lib/form'
import dp from 'dot-prop-immutable'
import { useT } from 'src/core/hooks/use-translation'

type Props = InputProps &
  TextAreaProps &
  Pick<FormItemProps, 'label' | 'required'> & {
    formikProps: any
    innerRef?: RefObject<InputAntd>
  }

function TextArea({
  cols,
  formikProps,
  label,
  name,
  placeholder,
  required = true,
  rows,
  allowClear
}: Props) {
  const { t } = useT()
  const { TextArea } = InputAntd
  const error = useMemo(() => {
    return dp.get(formikProps.errors, name)
  }, [formikProps.errors, name])

  const touched = useMemo(() => {
    return dp.get(formikProps.touched, name)
  }, [formikProps.touched, name])

  const value = useMemo(() => {
    return dp.get(formikProps.values, name)
  }, [formikProps.values, name])

  return (
    <Form.Item
      colon={false}
      hasFeedback={required}
      help={touched && typeof error === 'string' ? t(error) : ''}
      label={t(label)}
      required={required}
      validateStatus={
        error && touched ? 'error' : !error && touched ? 'success' : ''
      }
    >
      <TextArea
        allowClear={!required}
        cols={cols}
        name={name}
        onBlur={formikProps.handleBlur}
        onChange={value => formikProps.handleChange(value)}
        placeholder={t(placeholder)}
        rows={rows}
        value={value}
      />
    </Form.Item>
  )
}

export default TextArea
